import { getConfig } from '@klpkonsern/appconfig';

// Extend AppConfigParameters for this module
declare global {
    interface AppConfigParameters {
        WEBAPP_APP_BASE_PATH: string;
    }
}

const replaceSlash = (input: string) => {
    return input.replace(/\/{2,}/g, '/');
};

export const generateRouteWithBase = (
    routePath: string | Array<string | number | undefined>,
    prefix?: string,
): string => {
    const pathToFilter =
        typeof routePath === 'string' ? [routePath] : routePath;
    const path = pathToFilter.filter((fragment) => fragment !== undefined);
    const output = [
        prefix ? prefix : getConfig('WEBAPP_APP_BASE_PATH', '/'),
        ...path,
    ].join('/');
    if (output.substring(0, 4) === 'http') {
        const [protocol, ...rest] = output.split('//');
        return [protocol, replaceSlash(rest.join('/'))].join('//');
    }

    return replaceSlash('/' + output);
};

export const generateRoute = (
    routePath: string | Array<string | number | undefined>,
    appBasePath?: string,
): string => generateRouteWithBase(routePath, appBasePath);

export function generatePath(
    ...fragments: Array<string | number | undefined>
): string {
    const path = fragments.filter((fragment) => fragment !== undefined);
    const output = path.join('/');
    if (output.substring(0, 4) === 'http') {
        const [protocol, ...rest] = output.split('//');
        return [protocol, replaceSlash(rest.join('/'))].join('//');
    }

    return replaceSlash('/' + output);
}

export const generateRouteParams = (instance: object): string =>
    '?'.concat(
        Object.getOwnPropertyNames(instance)
            .filter((prop) => typeof instance[prop] !== 'function')
            .map((param) => `${param}=${instance[param]}`)
            .join('&'),
    );
